export default __webpack_public_path__ + "static/media/javascript.d7f2d6f8.png";